<template>
  <div></div>
</template>

<script>
import { APP_BASE_URL } from "@/var";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LoginByToken",

  computed: {
    ...mapGetters(["getAuthUser"]),
  },

  data() {
    return {
      account_types: ["school", "teacher", "parent", "student"],
    };
  },

  created() {
    this.loginUser();
  },

  mounted() {
    this.$bus.$emit("show_loader", "Logging in...Please wait");
  },

  methods: {
    ...mapActions(["loginUserByToken"]),

    loginUser() {
      let token = this.$route.params.token;
      this.loginUserByToken(token)
        .then((response) => {
          // console.log("TOKEN LOGIN RESPONSE>>>>", response, token);
          this.$bus.$emit("hide_loader");
          if (response.code === 200) {
            // CHECK PATH
            if (this.$route.query.path) {
              // CHECK FOR MULTPLE QUERY PARAMS
              let paths = this.$route.query.path.split(";");

              if (paths.length > 1) {
                let url_base_path = paths[0];

                paths.map((path, index) => {
                  if (index !== 0) url_base_path += `&${path}`;
                });
                location.href = `${APP_BASE_URL}/${url_base_path}`;
                // location.href = `http://localhost:8085/${url_base_path}`;
              } else {
                location.href = `${APP_BASE_URL}/${this.$route.query.path}`;
              }
            } else {
              if (this.getUserType() === "school")
                this.$router.push(`/${this.getUserType()}/dashboard`);
              else this.$router.push(`/${this.getUserType()}/feeds/0`);
            }
          } else {
            history.back()
              ? history.back()
              : (location.href = "https://gradely.ng/pages/tutoring");
          }
        })
        .catch((err) => {
          this.$bus.$emit("hide_loader");
          console.log("error logging in", err);
          history.back()
            ? history.back()
            : (location.href = "https://gradely.ng/pages/tutoring");
        });
    },

    getUserType() {
      return this.account_types[Number(this.getAuthUser.cap_token.slice(-1))];
    },
  },
};
</script>

<style></style>
